var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"app-wrapper"},[_c('div',{class:_vm.$route.name,attrs:{"id":"app"}},[_c('transition',{attrs:{"name":"page"}},[_c('router-view',{attrs:{"bg-image":(_vm.publicPath + "/img/downloading.png")}})],1)],1)])}
var staticRenderFns = []

export { render, staticRenderFns }